export default __webpack_public_path__ + "static/assets/7ad5cc6ed3d0a5fd6a273078fe3999f0.svg";